<template>
  <v-app
    class="bg-dark"
    :style="{
      backgroundImage: `linear-gradient(rgba(2, 2, 2, 0.85), rgba(0, 0, 0, 0.75)), url('${backgroundUrl}')`,
      backgroundSize: '100%',
      minHeight: '100vh'
    }"
    id="inspire"
  >
    <div id="challange-target">hidden</div>

    <div
      v-if="showLoading"
      wire:loading
      class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center"
    >
      <div
        class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"
      ></div>
      <h2 class="text-center text-white text-xl font-semibold">Loading...</h2>
      <p class="w-1/3 text-center text-white">
        if it takes more than 5 seconds, please refresh the page.
      </p>
    </div>

    <v-container v-else class="fill-height marginTop" fluid>
      <v-row align="center" justify="center">
        <v-col md="12">
          <div
            class="sm:mt-6 mx-auto grid grid-cols-1 gap-4 sm:px-6 lg:grid-flow-col-dense lg:grid-cols-12"
          >
            <div class="-mt-8 block sm:hidden text-center mx-auto">
              <sequential-entrance tag="section">
                <v-btn
                  v-show="!loggedIn"
                  @click="isBuyer()"
                  class="profile-card__button button--green"
                  dark
                  >Create Free Account to
                  <span class="uppercase font-bold"> get started </span></v-btn
                >
                <div class="sm:flex sm:justify-center">
                  <v-btn
                    @click="isSearch()"
                    class="profile-card__button button--blue"
                    dark
                    >Search More Homes</v-btn
                  >
                </div>
              </sequential-entrance>
            </div>

            <div class="sm:col-span-2">
              <div v-if="listing.PanoImages">
                <div v-if="listing.PanoImages.length > 0">
                  <div
                    v-for="(image, index) in listing.PanoImages"
                    :key="index"
                  >
                    <div
                      v-if="image.enable == '0'"
                      class="mb-4 bg-white p-2 rounded-md"
                    >
                      <div class="relative">
                        <div
                          class="absolute inset-0 flex items-center"
                          aria-hidden="true"
                        >
                          <div class="w-full border-t border-gray-300"></div>
                        </div>
                        <div class="relative flex justify-center">
                          <span class="px-2 bg-white text-sm text-gray-500">
                            <span
                              class="mt-1 text-3xl font-extrabold text-gray-800 sm:tracking-tight uppercase"
                            >
                              360 MEDIA
                            </span>
                          </span>
                        </div>
                      </div>

                      <template v-if="image.media_type == 'img'">
                        <span
                          @click="displayImage(image)"
                          class="absolute z-10 cursor-pointer center mt-1 ml-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800"
                          >View</span
                        >
                        <img
                          :src="image.media_url"
                          class="mt-2 object-cover shadow-lg rounded-lg"
                        />
                      </template>

                      <template v-else-if="image.media_type == 'video'">
                        <!-- relative flex justify-center items-center  -->
                        <div
                          @click="displayImage(image)"
                          :class="
                            image.enable ? 'block sm:hidden' : 'hidden sm:block'
                          "
                          class="cursor-pointer"
                        >
                          <i
                            class="absolute z-10 far fa-play-circle bg-white p-1 rounded-full"
                          ></i>
                          <video
                            controls
                            class="w-full object-cover shadow-lg rounded-lg"
                          >
                            <source :src="image.media_url" type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      </template>
                    </div>

                    <div
                      v-else
                      :class="
                        image.enable
                          ? 'bg-white mb-4 p-2 rounded-md sm:hidden'
                          : ''
                      "
                    >
                      <div class="relative">
                        <div
                          class="absolute inset-0 flex items-center"
                          aria-hidden="true"
                        >
                          <div class="w-full border-t border-gray-300"></div>
                        </div>
                        <div class="relative flex justify-center">
                          <span class="px-2 bg-white text-sm text-gray-500">
                            <span
                              class="mt-1 text-3xl font-extrabold text-gray-800 sm:tracking-tight uppercase"
                            >
                              Media
                            </span>
                          </span>
                        </div>
                      </div>

                      <template v-if="image.media_type == 'img'">
                        <span
                          @click="displayImage(image)"
                          class="absolute z-10 cursor-pointer center mt-1 ml-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800"
                          >View</span
                        >
                        <img
                          :src="image.media_url"
                          class="mt-2 object-cover shadow-lg rounded-lg"
                        />
                      </template>

                      <template v-else-if="image.media_type == 'video'">
                        <!-- relative flex justify-center items-center  -->
                        <div
                          @click="displayImage(image)"
                          :class="
                            image.enable ? 'block sm:hidden' : 'hidden sm:block'
                          "
                          class="cursor-pointer"
                        >
                          <i
                            class="absolute z-10 far fa-play-circle bg-white p-1 rounded-full"
                          ></i>
                          <video
                            controls
                            class="w-full object-cover shadow-lg rounded-lg"
                          >
                            <source :src="image.media_url" type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="space-y-6 sm:col-span-8">
              <v-card elevation="24" class="mx-auto">
                <template v-if="displayModal">
                  <template v-if="imageUrl.media_type == 'img'">
                    <Pano class="newHeight" :source="imageUrl.media_url"></Pano>
                  </template>
                  <template v-else-if="imageUrl.media_type == 'video'">
                    <video
                      v-if="imageUrl.enable"
                      class="w-full object-cover shadow-lg rounded-lg"
                      controls
                    >
                      <source :src="imageUrl.media_url" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    <panoramic
                      v-else
                      class="newHeight"
                      :source="imageUrl.media_url"
                      type="video"
                    ></panoramic>
                  </template>
                </template>

                <!-- <img
                  v-else-if="selectedImage"
                  class="newHeight object-cover"
                  :src="selectedImage"
                /> -->

                <v-carousel
                  v-else-if="selectedImage"
                  hide-delimiter-background
                  delimiter-icon="mdi-minus"
                  :hide-delimiters="true"
                >
                  <v-carousel-item
                    v-for="(image, indexado) in newImages"
                    :key="indexado"
                    :src="image"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  ></v-carousel-item>
                </v-carousel>

                <v-carousel
                  v-else
                  cycle
                  hide-delimiter-background
                  delimiter-icon="mdi-minus"
                  :hide-delimiters="true"
                >
                  <v-carousel-item
                    v-for="(image, index) in listing.Images"
                    :key="index"
                    :src="image"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  ></v-carousel-item>
                </v-carousel>

                <div
                  :class="changeDiv"
                  class="grid grid-cols-4 sm:grid sm:grid-cols-10 gap-2 p-2"
                >
                  <template v-if="selectedImage">
                    <div v-for="(image, idx) in newImages" :key="idx">
                      <img
                        @click="showImage(image, newImages)"
                        class="object-cover h-16 w-full mt-2"
                        :src="image"
                      />
                    </div>
                  </template>
                  <div v-else v-for="(image, idx) in listing.Images" :key="idx">
                    <img
                      @click="showImage(image, listing.Images)"
                      class="object-cover h-16 w-full mt-2"
                      :src="image"
                    />
                  </div>
                </div>

                <div
                  v-if="listing.Images.length > 9"
                  class="sm:col-span-12 relative"
                >
                  <div
                    class="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div class="w-full border-t border-gray-300"></div>
                  </div>
                  <div class="relative flex justify-center">
                    <button
                      @click="displayImages()"
                      type="button"
                      class="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      <svg
                        class="-ml-1.5 mr-1 h-5 w-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <span> View All {{ listing.Images.length }} </span>
                    </button>
                  </div>
                </div>

                <div
                  v-if="user"
                  x-data="{ tooltip3: false }"
                  class="float-right z-10"
                >
                  <span
                    v-if="containUser(user, listing)"
                    class="inline-flex items-center"
                  >
                    <button
                      @click="unMarkFavorite(listing)"
                      x-on:mouseover="tooltip3 = true"
                      x-on:mouseleave="tooltip3 = false"
                      class="text-indigo-500 hover:text-indigo-600"
                    >
                      <i class="fas fa-bookmark"></i>
                    </button>

                    <div
                      class="absolute ml-4 w-full"
                      x-cloak
                      x-show.transition.origin.top="tooltip3"
                    >
                      <div
                        class="absolute px-2 text-sm text-white bg-indigo-900 z-10 shadow rounded-lg hover:shadow-lg"
                      >
                        Marked as Favorite
                      </div>
                    </div>
                  </span>

                  <span v-else class="inline-flex items-center">
                    <button
                      @click="markFavorite(listing)"
                      x-on:mouseover="tooltip3 = true"
                      x-on:mouseleave="tooltip3 = false"
                      class="text-indigo-500 hover:text-indigo-600"
                    >
                      <i class="far fa-bookmark"></i>
                    </button>

                    <div
                      class="absolute ml-4 w-full"
                      x-cloak
                      x-show.transition.origin.top="tooltip3"
                    >
                      <div
                        class="absolute px-2 text-sm text-indigo-900 bg-indigo-50 z-10 shadow rounded-lg hover:shadow-lg"
                      >
                        Mark as Favorite
                      </div>
                    </div>
                  </span>
                </div>

                <v-card-text class="bg-white z-10">
                  <div class="display-1 float-right">
                    ${{
                      parseFloat(listing.ListPrice)
                        .toLocaleString()
                        .replace(".", ",")
                    }}
                  </div>

                  <h3 class="display-1 font-weight-light blue--text mb-2">
                    <small class="text-base sm:text-xl">
                      {{ listing.City }} </small
                    ><br />
                    <span class="text-lg sm:text-2xl">
                      {{ listing.StreetNumber }} {{ listing.StreetName }}
                      {{ listing.StreetSuffix }} {{ listing.StateOrProvince }}
                      {{ listing.PostalCode }}
                    </span>
                  </h3>

                  <v-divider></v-divider>
                  <div class="mt-2 mb-2 text-center">
                    <v-chip class="m-1">
                      <b class="mr-1"> Architecture: </b
                      >{{ listing.ArchitecturalStyle }}
                    </v-chip>
                    <v-chip class="m-1">
                      <b class="mr-1">Electric Source </b
                      >{{ listing.ElectricSource }}
                    </v-chip>
                    <v-chip class="m-1">
                      <b class="mr-1">Lot size: </b
                      >{{ listing.LivingAreaRange }}
                    </v-chip>
                    <v-chip class="m-1">
                      <b class="mr-1">Bathroom: </b
                      >{{ listing.BathroomsTotalInteger }}</v-chip
                    >
                    <v-chip class="m-1">
                      <b class="mr-1">Days On Market: </b
                      >{{ listing.DaysOnMarket }}</v-chip
                    >
                    <v-chip class="m-1">
                      <b class="mr-1">Bedroom: </b>{{ listing.BedroomsTotal }}
                    </v-chip>
                    <v-chip class="m-1">
                      <b class="mr-1">Rooms Total: </b>{{ listing.RoomsTotal }}
                    </v-chip>
                    <v-chip class="m-1">
                      <b class="mr-1">Sewer: </b>{{ listing.Sewer }}
                    </v-chip>
                    <v-chip class="m-1">
                      <b class="mr-1">Year Built: </b> {{ listing.YearBuilt }}
                    </v-chip>
                  </div>
                  <v-divider></v-divider>

                  <div class="mt-4">
                    <div class="descinline">
                      {{ listing.PublicRemarks | shortText(250) }}
                      ..........
                    </div>
                    <div class="descempty">
                      <p style="white-space: pre-wrap;">
                        {{ listing.PublicRemarks }}
                      </p>
                    </div>
                    <a
                      class="linkCustom"
                      style="color: red;"
                      v-if="listing.PublicRemarks.length >= 250"
                      @click="toggler($event)"
                    >
                      Continue reading
                    </a>
                  </div>

                  <div class="mt-4 border-t border-gray-200 px-4 py-5 sm:px-6">
                    <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3">
                      <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                          School Information for Districts
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                          {{ listing.ElementarySchool }}
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                          Buyer Financing:
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                          {{ listing.BuyerFinancing }}
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                          Association YNV:
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                          {{ listing.AssociationYNV }}
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                          Confirmed Special Assessments
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                          {{ listing.ConfirmedSpecialAssessments }}
                        </dd>
                      </div>

                      <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                          Construction Materials:
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                          {{ listing.ConstructionMaterials }}
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                          Dining Room Features:
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                          {{ listing.DiningRoomFeatures }}
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                          Exterior Amenities:
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                          {{ listing.ExteriorAmenities }}
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm font-medium text-gray-500">
                          Exterior Features:
                        </dt>
                        <dd class="mt-1 text-sm text-gray-900">
                          {{ listing.ExteriorFeatures }}
                        </dd>
                      </div>

                      <!-- <div class="relative sm:col-span-3">
                        <div
                          class="absolute inset-0 flex items-center"
                          aria-hidden="true"
                        >
                          <div class="w-full border-t border-gray-300"></div>
                        </div>
                        <div class="relative flex justify-center">
                          <button
                            type="button"
                            class="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            <svg
                              class="-ml-1.5 mr-1 h-5 w-5 text-gray-400"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                                clip-rule="evenodd"
                              />
                            </svg>
                            <span>Show More</span>
                          </button>
                        </div>
                      </div> -->

                      <div v-if="displayMore" class="sm:col-span-3">
                        <div class="sm:col-span-3">
                          <dt class="text-sm font-medium text-gray-500">
                            Appliances:
                          </dt>
                          <dd class="mt-1 text-sm text-gray-900">
                            {{ listing.Appliances }}
                          </dd>
                        </div>

                        <div class="sm:col-span-3">
                          <dt class="text-sm font-medium text-gray-500">
                            Interior Features:
                          </dt>
                          <dd class="mt-1 text-sm text-gray-900">
                            {{ listing.InteriorFeatures }}
                          </dd>
                        </div>

                        <small><b>Fireplace:</b></small>
                        {{ listing.FireplaceYN }} <br />

                        <small><b>Flooring:</b></small>
                        {{ listing.Flooring }} <br />

                        <small><b>Garage Spaces:</b></small>
                        {{ listing.GarageSpaces }} <br />

                        <small><b>Garages:</b></small>
                        {{ listing.Garages }} <br />

                        <small><b>Heating:</b></small>
                        {{ listing.Heating }} <br />

                        <small><b>Inclusions:</b></small>
                        {{ listing.Inclusions }} <br />

                        <small><b>Lot Size Acres Range:</b></small>
                        {{ listing.LotSizeAcresRange }} <br />

                        <small><b>SubDivision Name:</b></small>
                        {{ listing.SubDivisionName }} <br />

                        <small><b>Terms:</b></small>
                        {{ listing.Terms }} <br />

                        <small><b>Buyer Financing:</b></small>
                        {{ listing.BuyerFinancing }} <br />
                      </div>
                    </dl>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <div>
              <div class="hidden sm:inline-block sm:fixed">
                <sequential-entrance tag="section">
                  <v-btn
                    v-show="!loggedIn"
                    @click="isBuyer()"
                    class="profile-card__button button--green"
                    dark
                    >Create Free Account to
                    <span class="uppercase font-bold">
                      get started
                    </span></v-btn
                  >
                  <div class="sm:flex sm:justify-center">
                    <v-btn
                      @click="isSearch()"
                      class="profile-card__button button--blue"
                      dark
                      >Search More Homes</v-btn
                    >
                  </div>
                </sequential-entrance>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import { Pano } from "vuejs-vr";
import { mapGetters } from "vuex";
import Panoramic from "./Panoramic";

export default {
  components: { Pano, Panoramic },
  data() {
    return {
      listing: "",
      displayMore: false,
      backgroundUrl: "",
      propertyListing: "",
      showLoading: true,
      imageUrl: [],
      displayModal: false,
      selectedImage: "",
      showButtonImages: false,
      newImages: ""
    };
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  },

  computed: {
    filteredImgs() {
      return this.newImages;
    },

    changeDiv() {
      if (this.showButtonImages) {
        return "max-h-full";
      } else {
        return "overflow-hidden max-h-20";
      }
    },

    urlImageFile() {
      return this.imageUrl;
    },

    ...mapGetters({
      user: "userLogin",
      loggedIn: "userAuth"
    })
  },

  mounted() {},

  created() {
    //this.listing = this.$route.params.rental;
    this.getListingProperty();
  },

  methods: {
    isBuyer() {
      this.$router.push({
        name: "BuyerRegister",
        params: { state: "Buyer" }
      });
    },

    isSearch() {
      this.$router.push({
        name: "listings"
      });
    },

    displayImages() {
      this.showButtonImages = !this.showButtonImages;
    },

    containUser(user, listing) {
      let value = user.searches.filter(
        value => value.listingId === listing.ListingKeyNumeric
      );
      if (value.length > 0) {
        if (value[0].favorite == "1") {
          return true;
        }
      } else {
        return false;
      }
    },

    displayImage(url) {
      this.imageUrl = url;
      this.displayModal = true;
      console.log(url);
    },

    contact(listing) {
      this.$router.push({
        name: "ContactHouse",
        params: { listing }
      });
    },

    goHome() {
      this.$router.push({ name: "Home" });
    },

    getListingProperty() {
      window.axios
        .get("api/singleListing/" + this.$route.params.id)
        .then(res => {
          this.listing = res.data[0];
          this.backgroundUrl = res.data[0].Images[0];
          this.showLoading = false;
        });
    },

    toggler(e) {
      if (e.target.innerText == "Continue reading") {
        e.target.innerText = "Read Less";
        event.target.parentElement.children[0].className = "";
        event.target.parentElement.children[0].className = "descempty";
        event.target.parentElement.children[1].className = "";
        event.target.parentElement.children[1].className = "descinline";
      } else {
        e.target.innerText = "Continue reading";
        event.target.parentElement.children[0].className = "descinline";
        event.target.parentElement.children[1].className = "descempty";
      }
    },

    markFavorite(listing) {
      window.axios
        .get("api/markFavorite/" + listing.ListingKeyNumeric)
        .then(() => {
          this.$store.dispatch("getUser");
        });
    },

    unMarkFavorite(listing) {
      window.axios
        .get("api/unMarkFavorite/" + listing.ListingKeyNumeric)
        .then(() => {
          this.$store.dispatch("getUser");
        });
    },

    showImage(img, allImages) {
      this.displayModal = false;
      this.selectedImage = img;

      let idxImages = allImages.filter(e => e !== img);
      idxImages.unshift(img);
      this.newImages = idxImages;
    }
  }
};
</script>

<style lang="scss" scoped>
.descempty {
  display: none;
}
.descinline {
  display: block;
}

.modal .modal-dialog {
  width: 100%;
  height: 100%;
  max-width: 95%;
  min-height: 100vh;
}

.newHeight {
  width: 100%;
  height: 32em;
  margin: 0;
  padding: 0;
  border: 0;
}
</style>
